'use strict';

var _ = require('lodash');
var FaresOptimizerCSVExportService = function FaresOptimizerCSVExportService($filter, fileSaveService, app, faresOptimizerConstants, momentService, momentConstants) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function exportToCSVFormat(data, type, recommendationLevel) {
    var headerRows = getHeaderRows(recommendationLevel);
    var dataRows = getDataRows(data, recommendationLevel);
    var allRows = _.concat(headerRows, dataRows);
    fileSaveService.createFile(getFileDataFromRows(allRows), 'text/csv;charset=utf-8', getFilePrefix(type, data[0].market) + '.csv');
  }
  function getHeaderRows(recommendationLevel) {
    var headerMetadata = recommendationLevel === 'STRUCTURAL' ? headerStructuralMetadata : headerTacticalMetadata;
    var headerRows = [];
    headerRows.push(_.map(headerMetadata, 'label'));
    return headerRows;
  }
  function getDataRows(data, recommendationLevel) {
    var dataRows = [];
    _.forEach(data, function (rowData) {
      var rowGroups = getUnexpiredRecommendations(rowData.rowGroups);
      _.forEach(rowGroups, function (rowGroupData) {
        _.forEach(rowGroupData.groupedRows, function (groupedRowData) {
          dataRows.push(getDataRow(rowData, groupedRowData, recommendationLevel));
        });
      });
    });
    return dataRows;
  }
  function getUnexpiredRecommendations(rowGroups) {
    return _.filter(rowGroups, function (rowGroup) {
      return !rowGroup.isExpired;
    });
  }
  function getStructuralDataRow(rowData, groupedRowData) {
    var dataRow = [];
    dataRow.push(groupedRowData.hostCarrier, rowData.market, rowData.cabin, groupedRowData.season, groupedRowData.dow, groupedRowData.tripType, groupedRowData.fbc, groupedRowData.fareBrandName, rmMomentFormat(groupedRowData.effectiveDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.discontinueDate, 'DATE_ISO'), groupedRowData.advancePurchase, ' ' + groupedRowData.apGroup + ' ', groupedRowData.mmsGroup, groupedRowData.currencyCode, groupedRowData.currentFareTotal, groupedRowData.recommendedFareTotal, groupedRowData.fareChangeAbsolute, Math.round(groupedRowData.fareChangePercentage * 100), groupedRowData.effectiveFareChangeAbsolute, groupedRowData.currentFareBase, groupedRowData.recommendedFareBase, groupedRowData.distributedFare, groupedRowData.compFareSource, groupedRowData.compCarrier, groupedRowData.compTripType, groupedRowData.compMarketFbc, groupedRowData.compFareBrandName, _.includes(groupedRowData.compFare, '&nbsp;') ? _.replace(groupedRowData.compFare, '&nbsp;', ' ') : groupedRowData.compFare, groupedRowData.status, groupedRowData.lastUpdated, getRecommendationReasons(groupedRowData.ladderRemarks), getNoRecommendationReasons(groupedRowData.ladderRemarks));
    return dataRow;
  }
  function getTacticalDataRow(rowData, groupedRowData) {
    var dataRow = [];
    dataRow.push(groupedRowData.hostCarrier, rowData.market, rowData.cabin, groupedRowData.season, groupedRowData.dow, groupedRowData.tripType, groupedRowData.fbc, groupedRowData.fareBrandName, rmMomentFormat(groupedRowData.effectiveDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.discontinueDate, 'DATE_ISO'), groupedRowData.advancePurchase, ' ' + groupedRowData.apGroup + ' ', groupedRowData.mmsGroup, groupedRowData.footnote, rmMomentFormat(groupedRowData.firstTicketDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.lastTicketDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelFromDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelToDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelCompleteDate, 'DATE_ISO'), groupedRowData.currencyCode, groupedRowData.currentFareTotal, groupedRowData.recommendedFareTotal, groupedRowData.fareChangeAbsolute, Math.round(groupedRowData.fareChangePercentage * 100), groupedRowData.effectiveFareChangeAbsolute, groupedRowData.currentFareBase, groupedRowData.recommendedFareBase, groupedRowData.distributedFare, groupedRowData.compFareSource, groupedRowData.compCarrier, groupedRowData.compTripType, groupedRowData.compMarketFbc, groupedRowData.compFareBrandName, _.includes(groupedRowData.compFare, '&nbsp;') ? _.replace(groupedRowData.compFare, '&nbsp;', ' ') : groupedRowData.compFare, groupedRowData.compFootnote, groupedRowData.status, groupedRowData.lastUpdated, getRecommendationReasons(groupedRowData.ladderRemarks), getNoRecommendationReasons(groupedRowData.ladderRemarks));
    return dataRow;
  }
  function getDataRow(rowData, groupedRowData, recommendationLevel) {
    return recommendationLevel === 'STRUCTURAL' ? getStructuralDataRow(rowData, groupedRowData) : getTacticalDataRow(rowData, groupedRowData);
  }
  var getRecommendationReasons = function getRecommendationReasons(ladderRemarks) {
    var recommendationReasons = '';
    if (!_.isUndefined(ladderRemarks) && !_.isUndefined(ladderRemarks.recommendationReasons)) {
      _.forEach(ladderRemarks.recommendationReasons, function (value, key) {
        recommendationReasons = recommendationReasons.concat('| ', key);
      });
      recommendationReasons = _.startsWith(recommendationReasons, '|') ? _.trimStart(recommendationReasons, '|') : recommendationReasons;
    }
    return recommendationReasons;
  };
  var getNoRecommendationReasons = function getNoRecommendationReasons(ladderRemarks) {
    var noRecommendationReasons = '';
    if (!_.isUndefined(ladderRemarks) && !_.isUndefined(ladderRemarks.noRecommendationReasons)) {
      _.forEach(ladderRemarks.noRecommendationReasons, function (value, key) {
        noRecommendationReasons = noRecommendationReasons.concat('|', key.concat(':', value));
      });
      noRecommendationReasons = _.startsWith(noRecommendationReasons, '|') ? _.trimStart(noRecommendationReasons, '|') : noRecommendationReasons;
    }
    return noRecommendationReasons;
  };
  var headerTacticalMetadata = [{
    field: 'hostCarrier',
    label: 'Host Carrier'
  }, {
    field: 'market',
    label: 'Market'
  }, {
    field: 'cabin',
    label: 'Cabin'
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'DOW'
  }, {
    field: 'tripType',
    label: 'Fare Type Indicator'
  }, {
    field: 'fbc',
    label: 'FBC'
  }, {
    field: 'fareBrandName',
    label: 'Host Fare Brand'
  }, {
    field: 'effDate',
    label: 'Eff Date'
  }, {
    field: 'discDate',
    label: 'Disc Date'
  }, {
    field: 'advancePurchase',
    label: 'Rec. AP'
  }, {
    field: 'apGroup',
    label: 'AP Group'
  }, {
    field: 'mmsGroup',
    label: 'MMS Group'
  }, {
    field: 'footnote',
    label: 'Footnote'
  }, {
    field: 'firstTicketDate',
    label: 'First Ticket'
  }, {
    field: 'lastTicketDate',
    label: 'Last Ticket'
  }, {
    field: 'travelFromDate',
    label: 'Travel From'
  }, {
    field: 'travelToDate',
    label: 'Travel To'
  }, {
    field: 'travelCompleteDate',
    label: 'Travel Complete'
  }, {
    field: 'hostCurrency',
    label: 'Host Currency'
  }, {
    field: 'totalFareCurrent',
    label: 'Total Fare Current'
  }, {
    field: 'totalFareRecommended',
    label: 'Total Fare Recommended'
  }, {
    field: 'fareChangeA',
    label: 'Fare Change A'
  }, {
    field: 'fareChangeP',
    label: 'Fare Change P'
  }, {
    field: 'fareChangeD',
    label: 'Fare Change D'
  }, {
    field: 'baseFareCurrent',
    label: 'Base Fare Current'
  }, {
    field: 'baseFareRecommended',
    label: 'Base Fare Recommended'
  }, {
    field: 'baseFareDistributed',
    label: 'Base Fare Distributed'
  }, {
    field: 'compFareSource',
    label: 'Competitor Fare Source'
  }, {
    field: 'compMatchAirline',
    label: 'Competitor Airline'
  }, {
    field: 'compTripType',
    label: 'Competitor Fare Type Indicator'
  }, {
    field: 'compMatchFBC',
    label: 'Competitor FBC'
  }, {
    field: 'compFareBrandName',
    label: 'Competitor Fare Brand'
  }, {
    field: 'compMatchFare',
    label: 'Competitor Fare'
  }, {
    field: 'compMatchFootnote',
    label: 'Competitor Foot Note'
  }, {
    field: 'status',
    label: 'Status'
  }, {
    field: 'lastUpdated',
    label: 'Last Updated'
  }, {
    field: 'recommendationReason',
    label: 'Reasons for Recommendation'
  }, {
    field: 'noRecommendationReason',
    label: 'Reasons for Failure'
  }];
  var headerStructuralMetadata = [{
    field: 'hostCarrier',
    label: 'Host Carrier'
  }, {
    field: 'market',
    label: 'Market'
  }, {
    field: 'cabin',
    label: 'Cabin'
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'DOW'
  }, {
    field: 'tripType',
    label: 'Fare Type Indicator'
  }, {
    field: 'fbc',
    label: 'FBC'
  }, {
    field: 'fareBrandName',
    label: 'Host Fare Brand'
  }, {
    field: 'effDate',
    label: 'Eff Date'
  }, {
    field: 'discDate',
    label: 'Disc Date'
  }, {
    field: 'advancePurchase',
    label: 'Rec. AP'
  }, {
    field: 'apGroup',
    label: 'AP Group'
  }, {
    field: 'mmsGroup',
    label: 'MMS Group'
  }, {
    field: 'hostCurrency',
    label: 'Host Currency'
  }, {
    field: 'totalFareCurrent',
    label: 'Total Fare Current'
  }, {
    field: 'totalFareRecommended',
    label: 'Total Fare Recommended'
  }, {
    field: 'fareChangeA',
    label: 'Fare Change A'
  }, {
    field: 'fareChangeP',
    label: 'Fare Change P'
  }, {
    field: 'fareChangeD',
    label: 'Fare Change D'
  }, {
    field: 'baseFareCurrent',
    label: 'Base Fare Current'
  }, {
    field: 'baseFareRecommended',
    label: 'Base Fare Recommended'
  }, {
    field: 'baseFareDistributed',
    label: 'Base Fare Distributed'
  }, {
    field: 'compFareSource',
    label: 'Competitor Fare Source'
  }, {
    field: 'compMatchAirline',
    label: 'Competitor Airline'
  }, {
    field: 'compTripType',
    label: 'Competitor Fare Type Indicator'
  }, {
    field: 'compMatchFBC',
    label: 'Competitor FBC'
  }, {
    field: 'compFareBrandName',
    label: 'Competitor Fare Brand'
  }, {
    field: 'compMatchFare',
    label: 'Competitor Fare'
  }, {
    field: 'status',
    label: 'Status'
  }, {
    field: 'lastUpdated',
    label: 'Last Updated'
  }, {
    field: 'recommendationReason',
    label: 'Reasons for Recommendation'
  }, {
    field: 'noRecommendationReason',
    label: 'Reasons for Failure'
  }];
  function formatAsCsvRow(stringArayToFormat) {
    var rowValues = _.chain(stringArayToFormat).map(function (value) {
      return '"' + value + '"';
    }).join(',').value();
    return rowValues + '\r\n';
  }
  function getFilePrefix(type, market) {
    return type === 'all' ? 'Export All FareRecommendation Grids' : 'Export FareRecommendation Grid ' + market;
  }
  function getFileDataFromRows(allRows) {
    return _.reduce(allRows, function (result, row) {
      var formattedRow = _.map(row, formatUndefinedData);
      var csvFormattedRow = formatAsCsvRow(formattedRow);
      result += csvFormattedRow;
      return result;
    }, '');
  }
  function formatUndefinedData(field) {
    return field || '';
  }
  function exportToSummaryCSVFormat(data) {
    var rowSortedByRbd = flattendAndSortByRbd(data, app.foCabins, app.seasonDefinitions, app.foRbds);
    var rbds = getAllRbds(rowSortedByRbd);
    var summaryDataHeader = getSummaryFileColumnHeaders(rbds);
    var summaryDataRows = getSummaryFileDataRows(data, rbds, rowSortedByRbd);
    var allRows = removeColumns(_.concat([summaryDataHeader], summaryDataRows));
    fileSaveService.createFile(getFileDataFromRows(allRows), 'text/csv;charset=utf-8', 'Export Summary Report.csv');
  }
  function removeColumns(summaryDataRows) {
    var exportData = [];
    var columnsToIgnore = [];
    var columnsToExport = [];
    var staticColumns = getSummaryFileColumnTitles();
    _.map(staticColumns, function (eachColumn, colIndex) {
      if (eachColumn.isRemove === true) {
        columnsToIgnore.push(colIndex);
      }
    });
    var staticAndDynamicColumns = summaryDataRows[0];
    _.map(summaryDataRows, function (eachRow, rowIndex) {
      if (rowIndex !== 0) {
        _.map(eachRow, function (eachCell, colIndex) {
          if (columnsToIgnore.indexOf(colIndex) === -1) {
            if (staticAndDynamicColumns[colIndex].split('Linked FBC').length > 1) {
              if (eachCell !== '' && eachCell !== faresOptimizerConstants.EN_DASH && columnsToExport.indexOf(colIndex) === -1) {
                columnsToExport.push(colIndex);
              }
            } else if (columnsToExport.indexOf(colIndex) === -1) {
              columnsToExport.push(colIndex);
            }
          }
        });
      }
    });
    if (columnsToExport.length === 0) {
      return summaryDataRows;
    }
    columnsToExport = _.sortBy(columnsToExport);
    _.map(summaryDataRows, function (eachRow, rowIndex) {
      exportData[rowIndex] = [];
      _.map(columnsToExport, function (columnIndex) {
        exportData[rowIndex].push(eachRow[columnIndex]);
      });
    });
    return exportData;
  }
  function getSeasonIndexMap(seasonDefinitions) {
    return _.reduce(seasonDefinitions, function (result, seasonDefinition) {
      result[seasonDefinition.season] = seasonDefinition.seasonIndex;
      return result;
    }, {});
  }
  function getFoSeasonAbbreviationMap(seasonDefinitions) {
    return _.reduce(seasonDefinitions, function (result, seasonDefinition) {
      result[seasonDefinition.season] = seasonDefinition.seasonAbbreviation;
      return result;
    }, {});
  }
  function flattendAndSortByRbd(marketLevelData, foCabins, seasonDefinitions, foRbd) {
    var seasonIndexMap = getSeasonIndexMap(seasonDefinitions);
    var seasonAbbreviationMap = getFoSeasonAbbreviationMap(seasonDefinitions);
    var flattenedRows = decorateAndFlattenToMarketFbcLevel(marketLevelData, foCabins, seasonIndexMap, seasonAbbreviationMap, foRbd);
    return sortForFbcOrder(flattenedRows);
  }
  function decorateAndFlattenToMarketFbcLevel(marketLevelData, foCabins, seasonIndexMap, seasonAbbreviationMap, foRbd) {
    var actionCodeDescription = {
      n: 'New Fare',
      c: 'Changed Fare',
      x: 'Cancelled Fare'
    };
    var flattenedRows = [];
    _.forEach(marketLevelData, function (marketLevelRow) {
      var rowGroups = getUnexpiredRecommendations(marketLevelRow.rowGroups);
      _.forEach(rowGroups, function (rowGroup) {
        _.forEach(rowGroup.groupedRows, function (row) {
          row['exportOrigin'] = rowGroup.origin;
          row['exportDestination'] = rowGroup.destination;
          row['exportCabin'] = rowGroup.cabin;
          row['exportTariffCode'] = rowGroup.tariffCode;
          row['exportRoutingNumber'] = rowGroup.routingNumber;
          row['exportFootnote'] = rowGroup.footnote;
          row['cabinIndex'] = _.indexOf(foCabins, row.cabin);
          row['seasonIndex'] = seasonIndexMap[row.season];
          row['seasonAbbreviation'] = seasonAbbreviationMap[row.season];
          row['classIndex'] = _.indexOf(foRbd, row.rbd);
          if (rowGroup.compFare) {
            var compFareDetails = rowGroup.compFare.split('&nbsp;');
            row['exportCompCurrency'] = compFareDetails[0];
            row['exportCompFare'] = compFareDetails[1];
          }
          row['exportCompFareSource'] = rowGroup.compFareSource;
          row['exportCompCarrier'] = rowGroup.compCarrier;
          row['exportCompAp'] = rowGroup.compAp;
          row['exportCompMarketFbc'] = rowGroup.compMarketFbc;
          row['exportSeason'] = rowGroup.season;
          row['exportActionCode'] = rowGroup.actionCode ? actionCodeDescription[rowGroup.actionCode.toLowerCase()] : '';
          row['exportDoW'] = rowGroup.dow;
          flattenedRows.push(row);
        });
      });
    });
    return flattenedRows;
  }
  function sortForFbcOrder(flattenedRows) {
    return _.orderBy(flattenedRows, ['classIndex'], ['asc']);
  }
  function getAllRbds(rowSortedByRbd) {
    return _.chain(rowSortedByRbd).groupBy('rbd').transform(function (result, rbdMarketLevelRow) {
      result.push(getRbds(rbdMarketLevelRow));
    }, []).value();
  }
  function getRbds(rbdMarketLevelRow) {
    return {
      rbd: rbdMarketLevelRow[0].rbd,
      hostCarrier: rbdMarketLevelRow[0].carrier
    };
  }
  function getSummaryFileColumnHeaders(summaryFileHeaderRawData) {
    var columnTitles = getSummaryFileColumnTitles();
    var columnHeaderRow = _.map(columnTitles, 'label');
    var fbcColumns = [];
    var linkedFbcColumns = [];
    var currFareColumns = [];
    var linkedFbcCurrFareColumns = [];
    var recomFareColumns = [];
    var linkedFbcRecomFareColumns = [];
    var apColumns = [];
    var linkedFbcApColumns = [];
    var obBlackoutColumns = [];
    var linkedFbcObBlackoutColumns = [];
    var ibBlackoutColumns = [];
    var linkedFbcIbBlackoutColumns = [];
    _.forEach(summaryFileHeaderRawData, function (fbcGroupRow) {
      var rbd = fbcGroupRow['rbd'];
      fbcColumns.push(getFbcColumn(fbcGroupRow.hostCarrier, rbd));
      linkedFbcColumns.push(getFbcColumn(fbcGroupRow.hostCarrier, rbd, true));
      currFareColumns.push(getCurrentFareColumn(rbd));
      linkedFbcCurrFareColumns.push(getCurrentFareColumn(rbd, true));
      recomFareColumns.push(getRecomFareColumn(rbd));
      linkedFbcRecomFareColumns.push(getRecomFareColumn(rbd, true));
      apColumns.push(getApColumn(rbd));
      linkedFbcApColumns.push(getApColumn(rbd, true));
      obBlackoutColumns.push(getObBlackoutColumn(rbd));
      linkedFbcObBlackoutColumns.push(getObBlackoutColumn(rbd, true));
      ibBlackoutColumns.push(getIbBlackoutColumn(rbd));
      linkedFbcIbBlackoutColumns.push(getIbBlackoutColumn(rbd, true));
    });
    return columnHeaderRow.concat(fbcColumns, linkedFbcColumns, ['Currency'], currFareColumns, linkedFbcCurrFareColumns, recomFareColumns, linkedFbcRecomFareColumns, apColumns, linkedFbcApColumns, obBlackoutColumns, linkedFbcObBlackoutColumns, ibBlackoutColumns, linkedFbcIbBlackoutColumns);
  }
  function getFbcColumn(carrier, rbd, isLinkedFbcColumn) {
    return carrier + (isLinkedFbcColumn ? ' Linked FBC (' + rbd + ')' : ' FBC (' + rbd + ')');
  }
  function getCurrentFareColumn(rbd, isLinkedFbcColumn) {
    return 'Curr (' + rbd + ')' + (isLinkedFbcColumn ? ' Linked FBC' : '');
  }
  function getRecomFareColumn(rbd, isLinkedFbcColumn) {
    return 'Recom (' + rbd + ')' + (isLinkedFbcColumn ? ' Linked FBC' : '');
  }
  function getApColumn(rbd, isLinkedFbcColumn) {
    return rbd + '_AP' + (isLinkedFbcColumn ? ' Linked FBC' : '');
  }
  function getObBlackoutColumn(rbd, isLinkedFbcColumn) {
    return rbd + '_OB_Blackout' + (isLinkedFbcColumn ? ' Linked FBC' : '');
  }
  function getIbBlackoutColumn(rbd, isLinkedFbcColumn) {
    return rbd + '_IB_Blackout' + (isLinkedFbcColumn ? ' Linked FBC' : '');
  }
  function getSummaryFileColumnTitles() {
    return [{
      field: 'hostCarrier',
      label: 'Host Carrier'
    }, {
      field: 'exportOrigin',
      label: 'ORI'
    }, {
      field: 'exportDestination',
      label: 'DES'
    }, {
      field: 'origin',
      label: 'ORI',
      isRemove: true
    }, {
      field: 'destination',
      label: 'DES',
      isRemove: true
    }, {
      field: 'cabin',
      label: 'Cabin',
      isRemove: true
    }, {
      field: 'exportCabin',
      label: 'Cabin'
    }, {
      field: 'tariffCode',
      label: 'Tariff Number',
      isRemove: true
    }, {
      field: 'exportTariffCode',
      label: 'Tariff Number'
    }, {
      field: 'routingNumber',
      label: 'Routing Number',
      isRemove: true
    }, {
      field: 'exportRoutingNumber',
      label: 'Routing Number'
    }, {
      field: 'exportFootnote',
      label: 'Footnote'
    }, {
      field: 'footnote',
      label: 'Footnote',
      isRemove: true
    }, {
      field: 'status',
      label: 'Status'
    }, {
      field: 'exportActionCode',
      label: 'Recommendation Type'
    }, {
      field: 'firstTicketDate',
      label: 'First Ticket Date'
    }, {
      field: 'lastTicketDate',
      label: 'Last Ticket Date'
    }, {
      field: 'travelFromDate',
      label: 'Travel From Date'
    }, {
      field: 'travelToDate',
      label: 'Travel To Date'
    }, {
      field: 'travelCompleteDate',
      label: 'Travel Completion Date'
    }, {
      field: 'exportCompFareSource',
      label: 'Comp Fare Source'
    }, {
      field: 'exportCompCarrier',
      label: 'Entry Level BMA'
    }, {
      field: 'exportCompMarketFbc',
      label: 'Comp FBC'
    }, {
      field: 'exportCompCurrency',
      label: 'Comp Currency'
    }, {
      field: 'exportCompFare',
      label: 'Comp total Fare'
    }, {
      field: 'compFootnote',
      label: 'Comp Footnote'
    }, {
      field: 'exportCompAp',
      label: 'Comp AP'
    }, {
      field: 'exportSeason',
      label: 'Season'
    }, {
      field: 'ticketingDates',
      label: 'Ticketing Dates'
    }, {
      field: 'reservationDates',
      label: 'Sale Dates'
    }, {
      field: 'outboundTravelDates',
      label: 'OB Travel Restriction'
    }, {
      field: 'inboundTravelDates',
      label: 'IB Travel Restriction'
    }, {
      field: 'outboundSeasons',
      label: 'OB Season'
    }, {
      field: 'inboundSeasons',
      label: 'IB Season'
    }, {
      field: 'daysOfWeek',
      label: 'Comp DOW'
    }, {
      field: 'tripType',
      label: 'Trip Type'
    }, {
      field: 'exportDoW',
      label: 'DoW'
    }, {
      field: 'hostEntryLevelFbc',
      label: 'Host Entry Level FBC',
      isRemove: true
    }, {
      field: 'fbc',
      label: 'FBC',
      isRemove: true
    }, {
      field: 'isLinkedFbc',
      label: 'Linked FBC',
      isRemove: true
    }, {
      field: 'category',
      label: 'Category',
      isRemove: true
    }];
  }
  function getSummaryFileDataRows(data, summaryFileHeaderRawData, rowSortedByRbd) {
    var rbdColumns = _.map(summaryFileHeaderRawData, 'rbd');
    populateMarketRoutingTariffFootnote(data, rowSortedByRbd);
    rowSortedByRbd = _.filter(rowSortedByRbd, 'uniqueRow');
    var fbcMarketFareMap = getFbcMarketFareMap(rowSortedByRbd);
    var summaryFileDataRows = getUniqueMarkets(data, rowSortedByRbd);
    ['fbc', 'linkedFbc', 'currency', 'currFare', 'linkedFbcCurrFare', 'effFare', 'linkedFbcEffFare', 'ap', 'linkedFbcAp', 'obBlackoutDates', 'linkedFbcObBlackoutDates', 'ibBlackoutDates', 'linkedFbcIbBlackoutDates'].forEach(function (column) {
      summaryFileDataRows = populateSummaryFileGridDataRows(summaryFileDataRows, rbdColumns, fbcMarketFareMap, column);
    });
    return summaryFileDataRows;
  }
  function isTactical(category) {
    return category === 'TACTICAL';
  }
  function getLinkedFbcFareMap(row, key, result) {
    var existingLinkedFbcBaseFare = result[key] ? result[key].linkedFbcCurrFare || 0 : 0;
    result[key]['linkedFbcCurrFare'] = Math.round(Math.max(existingLinkedFbcBaseFare, row.currentFareBase));
    var existingLinkedFbcEffectiveBaseFare = result[key] ? result[key].linkedFbcEffFare || 0 : 0;
    result[key]['linkedFbcEffFare'] = Math.round(Math.max(existingLinkedFbcEffectiveBaseFare, row.effectiveBaseFare));
    result[key]['linkedFbc'] = row.fbc;
    result[key]['linkedFbcAp'] = row.ap;
    result[key]['linkedFbcObBlackoutDates'] = pickAllDates(row.outboundBlackouts);
    result[key]['linkedFbcIbBlackoutDates'] = pickAllDates(row.inboundBlackouts);
    result[key]['currFare'] = result[key]['currFare'] ? result[key]['currFare'] : '';
    result[key]['effFare'] = result[key]['effFare'] ? result[key]['effFare'] : '';
    result[key]['fbc'] = result[key]['fbc'] ? result[key]['fbc'] : '';
    result[key]['ap'] = result[key]['ap'] ? result[key]['ap'] : '';
    result[key]['obBlackoutDates'] = result[key]['obBlackoutDates'] ? result[key]['obBlackoutDates'] : '';
    result[key]['ibBlackoutDates'] = result[key]['ibBlackoutDates'] ? result[key]['ibBlackoutDates'] : '';
  }
  function getFbcFareMap(row, key, result) {
    var existingBaseFare = result[key] ? result[key].currFare || 0 : 0;
    result[key]['currFare'] = Math.round(Math.max(existingBaseFare, row.currentFareBase));
    var existingEffectiveBaseFare = result[key] ? result[key].effFare || 0 : 0;
    result[key]['effFare'] = Math.round(Math.max(existingEffectiveBaseFare, row.effectiveBaseFare));
    result[key]['fbc'] = row.fbc;
    result[key]['ap'] = row.ap;
    result[key]['obBlackoutDates'] = pickAllDates(row.outboundBlackouts);
    result[key]['ibBlackoutDates'] = pickAllDates(row.inboundBlackouts);
    result[key]['linkedFbcCurrFare'] = result[key]['linkedFbcCurrFare'] ? result[key]['linkedFbcCurrFare'] : '';
    result[key]['linkedFbcEffFare'] = result[key]['linkedFbcEffFare'] ? result[key]['linkedFbcEffFare'] : '';
    result[key]['linkedFbc'] = result[key]['linkedFbc'] ? result[key]['linkedFbc'] : '';
    result[key]['linkedFbcAp'] = result[key]['linkedFbcAp'] ? result[key]['linkedFbcAp'] : '';
    result[key]['linkedFbcObBlackoutDates'] = result[key]['linkedFbcObBlackoutDates'] ? result[key]['linkedFbcObBlackoutDates'] : '';
    result[key]['linkedFbcIbBlackoutDates'] = result[key]['linkedFbcIbBlackoutDates'] ? result[key]['linkedFbcIbBlackoutDates'] : '';
  }
  function getFbcMarketFareMap(rowSortedByRbd) {
    return _.reduce(rowSortedByRbd, function (result, row) {
      var key = _.join([row.market, row.cabin, row.rbd, row.routingNumber, row.tariffCode, row.exportSeason, row.exportCompCarrier, row.hostEntryLevelFbc, row.isLinkedFbc, row.tripType, isTactical(row.category) ? '' : row.footnote], ':');
      result[key] = result[key] ? result[key] : {};
      row.isLinkedFbc ? getLinkedFbcFareMap(row, key, result) : getFbcFareMap(row, key, result);
      result['exportHostCurrency'] = row.currencyCode;
      return result;
    }, {});
  }
  function populateMarketRoutingTariffFootnote(data, rowSortedByRbd) {
    _.forEach(rowSortedByRbd, function (row) {
      if (row.exportSeason !== undefined) {
        row.uniqueRow = _.join([row.origin, row.destination, row.cabin, row.hostEntryLevelFbc, row.routingNumber, row.tariffCode, row.exportSeason, row.exportCompCarrier, row.isLinkedFbc, row.tripType, isTactical(row.category) ? '' : row.footnote], '-');
      }
    });
  }
  function getUniqueMarkets(data, rowSortedByRbd) {
    var columnTitles = getSummaryFileColumnTitles();
    var columnFields = _.map(columnTitles, 'field');
    var copyOfRowsSortedByRbd = _.cloneDeep(rowSortedByRbd);
    return _.chain(copyOfRowsSortedByRbd).groupBy('uniqueRow').map(function (row) {
      return _.transform(columnFields, function (result, fieldName) {
        var fieldValue = row[0][fieldName];
        if (fieldName.includes('Date') || fieldName === 'ticketingDates' || fieldName === 'reservationDates' || fieldName === 'outboundTravelDates' || fieldName === 'inboundTravelDates' || fieldName === 'outboundSeasons' || fieldName === 'inboundSeasons') {
          fieldValue = pickAllDates(fieldValue, fieldName === 'outboundTravelDates' || fieldName === 'inboundTravelDates');
        }
        result.push(fieldValue);
      }, []);
    }).value();
  }
  function pickAllDates(dateDetails, hasFromToCompleteDates) {
    var concatDates = [];
    if (momentService.isMoment(dateDetails)) {
      return rmMomentFormat(dateDetails, momentConstants.DAY_MONTH_YEAR);
    }
    _.map(dateDetails, function (eachDate) {
      var strDate = '';
      if (eachDate.begin || eachDate.from) {
        strDate = formatDateData(eachDate.begin || eachDate.from);
      }
      strDate += '-';
      if (eachDate.end || eachDate.to) {
        strDate += formatDateData(eachDate.end || eachDate.to);
      }
      if (hasFromToCompleteDates === true) {
        strDate += '-';
        if (eachDate.complete) {
          strDate += formatDateData(eachDate.complete);
        }
      }
      concatDates.push(strDate);
    });
    return concatDates.length > 0 ? concatDates.join(' | ') : formatDateData(dateDetails);
  }
  function formatDateData(data) {
    return _.isEmpty(data) ? '' : rmMomentFormat(momentService.of(data, momentService.FIELD.OPT_GROUP_DATE), momentConstants.DAY_MONTH_YEAR);
  }
  function populateSummaryFileGridDataRows(summaryFileDataRows, rbdColumns, fbcMarketFareMap, columnName) {
    _.forEach(summaryFileDataRows, function (marketRow) {
      if (columnName === 'currency') {
        marketRow.push(fbcMarketFareMap.exportHostCurrency);
      } else {
        _.forEach(rbdColumns, function (rbd) {
          var key = [marketRow[3] + '-' + marketRow[4], marketRow[5], rbd, marketRow[9] ? marketRow[9].trim() : '', marketRow[7] ? marketRow[7].trim() : '', marketRow[27] ? marketRow[27].trim() : '', marketRow[21] ? marketRow[21].trim() : '', marketRow[37] ? marketRow[37].trim() : '', marketRow[39], marketRow[35]];
          if (!isTactical(marketRow[40])) {
            key.push(marketRow[11] ? marketRow[11].trim() : '');
          }
          key = key.join(':');
          var keyWithFbc = key + ':' + (marketRow[39] ? marketRow[38] : '');
          marketRow.push(fbcMarketFareMap[keyWithFbc] ? fbcMarketFareMap[keyWithFbc][columnName] : fbcMarketFareMap[key] ? fbcMarketFareMap[key][columnName] : '');
        });
      }
    });
    return summaryFileDataRows;
  }
  return {
    exportToCSVFormat: exportToCSVFormat,
    exportToSummaryCSVFormat: exportToSummaryCSVFormat
  };
};
FaresOptimizerCSVExportService.$inject = ['$filter', 'FileSaveService', 'App', 'FaresOptimizerConstants', 'MomentService', 'MomentConstants'];
module.exports = FaresOptimizerCSVExportService;